if (!customElements.get('gastrotest-symptoms')) {
  customElements.define('gastrotest-symptoms', class extends HTMLElement {
    connectedCallback() {
      this.stack = this.querySelector('.gt-symptom-stack');
      this.cards = [...this.querySelectorAll('.gt-symptom-card')];
      this.links = [...this.querySelectorAll('.gt-symptom-progress a')];
      this.progress = this.querySelector('.gt-symptom-progress');
      if (!this.stack || !this.progress || !this.cards.length) return;

      this.update = () => {
        const stack = this.stack.getBoundingClientRect();
        const visible = stack.top < window.innerHeight * 0.72 && stack.bottom > window.innerHeight * 0.2;
        this.progress.classList.toggle('is-visible', visible);

        const stickyTop = parseFloat(getComputedStyle(this.cards[0]).top) || 0;
        let active = 0;
        this.cards.forEach((card, index) => {
          if (card.getBoundingClientRect().top <= stickyTop + 8) active = index;
        });

        this.cards.forEach((card, index) => card.classList.toggle('is-active', index === active));
        this.links.forEach((link, index) => {
          if (index === active) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
      };

      this.scheduleUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };

      window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
      window.addEventListener('resize', this.scheduleUpdate);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
